/**
 * Add-to-cart button inside a collection "Text card" block.
 *
 * Single-variant products render a form that is submitted with fetch so the
 * cart drawer / notification updates in place. Multi-variant products render a
 * quick-cart-drawer trigger (handled by quick-cart-drawer.js); if no drawer is
 * on the page the trigger falls back to navigating to the product page.
 */
if (!customElements.get('card-text-add-to-cart')) {
  class CardTextAddToCart extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.trigger = this.querySelector('.quick-cart-drawer__trigger');
      this.errorMessage = this.querySelector('.card-text__add-to-cart-error');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (this.form) {
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      if (this.trigger && !document.querySelector('quick-cart-drawer')) {
        this.trigger.addEventListener('click', () => {
          window.location.href = this.dataset.productUrl;
        });
      }
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.submitButton?.hasAttribute('disabled')) return;

      this.submitButton?.setAttribute('disabled', '');
      this.resetError();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.hasAttribute('data-has-pre-order')) {
        formData.append('properties[Pre-order]', '✓');
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.section));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then(response => response.json())
        .then(response => {
          if (response.status || response.errors) {
            this.showError(response.description || response.message || response.errors);
            return;
          }
          if (this.cart) {
            this.cart.renderContents(response);
          }
          if (typeof updateCartCounters === 'function') {
            updateCartCounters();
          }
        })
        .catch(error => {
          console.error(error);
          this.showError();
        })
        .finally(() => {
          this.submitButton?.removeAttribute('disabled');
        });
    }

    showError(message) {
      if (!this.errorMessage) return;
      this.errorMessage.textContent = message || window.cartStrings?.error || 'Something went wrong. Please try again.';
      this.errorMessage.removeAttribute('hidden');
      clearTimeout(this.errorTimeout);
      this.errorTimeout = setTimeout(() => this.resetError(), 5000);
    }

    resetError() {
      if (!this.errorMessage) return;
      this.errorMessage.setAttribute('hidden', '');
      this.errorMessage.textContent = '';
    }
  }

  customElements.define('card-text-add-to-cart', CardTextAddToCart);
}
